import {
  REQUEST_PREOPEN_CLAIM,
  REQUEST_OPEN_CLAIM_MANAGER,
  REQUEST_OPEN_CLAIM_GPO,
  REQUEST_COMPLETE_CLAIM_LAWYER_GPO,
  REQUEST_MIGRATE_CLAIM,
  REQUEST_VALIDATE_COMPLETE_CLAIM,
} from 'containers/RecapPage/constants';

export const requestPreopenClaim = (
  claimToPreOpen: any,
  successCallback: Function,
) => ({
  type: REQUEST_PREOPEN_CLAIM,
  claimToPreOpen,
  successCallback,
});
export const requestOpenClaimManager = (
  claimToOpen: any,
  successCallback: Function,
) => ({
  type: REQUEST_OPEN_CLAIM_MANAGER,
  claimToOpen,
  successCallback,
});

export const requestOpenClaimGpo = (
  claimToOpen: any,
  successCallback: Function,
  failCallBack?: Function,
) => ({
  type: REQUEST_OPEN_CLAIM_GPO,
  claimToOpen,
  successCallback,
  failCallBack,
});

export const requestMigrateClaim = (claim: any, successCallback: Function) => ({
  type: REQUEST_MIGRATE_CLAIM,
  claim,
  successCallback,
});

export const requestCompleteClaim = (
  payload: any,
  successCallback: Function,
) => ({
  type: REQUEST_COMPLETE_CLAIM_LAWYER_GPO,
  payload,
  successCallback,
});

export const requestValidateCompleteClaim = (
  payload: any,
  successCallback: Function,
) => ({
  type: REQUEST_VALIDATE_COMPLETE_CLAIM,
  payload,
  successCallback,
});
